import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getProviderAdsReviews = createAsyncThunk(
  "providerAdsReviews/fetchAll",
  async ({ page = 1 } = {}, { rejectWithValue }) => {
    try {
      const token = JSON.parse(sessionStorage.getItem("user3ayin"))?.token;

      const response = await axios.get(
        `${BASE_URL}/api/provider/reviews/ads?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Lang: i18n.language,
          },
        }
      );

      return {
        data: response.data?.data || [],
        pagination: response.data?.pagination || {},
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const initialState = {
  providerAdsReviews: [],
  pagination: {},
  isLoading: false,
  error: null,
  success: null,
};

const ProviderAdsReviewsSlice = createSlice({
  name: "providerAdsReviews",
  initialState,
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProviderAdsReviews.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProviderAdsReviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.providerAdsReviews = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getProviderAdsReviews.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearState } = ProviderAdsReviewsSlice.actions;
export default ProviderAdsReviewsSlice.reducer;
